/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailNavController', ProjectDetailNavController);

    ProjectDetailNavController.$inject = ['$stateParams', 'entity'];

    function ProjectDetailNavController($stateParams, entity) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.project = entity;
    }
})();
